import { render } from "./Purchase.vue?vue&type=template&id=02d75c0b"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__